import { BookingDetailsFluVaccineModel  } from '../../../models/booking/booking-details.model';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { Utility } from '../../../common/utility';
import { BookingUrl } from '../../../shared/urls/booking.url';

@Injectable( )
    export class BookingDetailFluVaccineService {
        constructor (
            public baseService: BaseService) { }
    //  getDataRowListStaff() {
    //     return dataRow;
    //  }
    //  getDataDetailsFluVaccine() {
    //     return bookingDetailsFluVaccine;
    //  }

    getFluVaccineBookingDetail(id, param) {
        const url = BookingUrl.GET_FLUVACCINE_BOOKING.replace('{id}', id);
        return this.baseService.getData(url, param);
    }

    updateFluVaccineBookingDetail(param){
        const url = BookingUrl.UPDATE_FLUVACCINE_BOOKING;
        return this.baseService.put(url, param);
    }
}

export const dataRow = [
    {
        id: '1',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '2',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '3',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '4',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '5',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '6',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '1',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '2',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '3',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '4',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '5',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    },
    {
        id: '6',
        tmbStaff: 'Dr.Thanh',
        patient: 'Hung Vuong'
    }
];

// export const bookingDetailsFluVaccine: BookingDetailsFluVaccineModel = {
//     id: '1',
//     bookingRef: 'B010',
//     administeredDate: '2017-09-10T14:16:00',
//     fromTime: '10:00AM',
//     toTime: '10:30AM',
//     groupName: 'Group Name',
//     members: [],
// };



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/booking-detail/booking-detail-fluvaccine.service.ts